import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { handleLoadExerciseDetailsData } from 'modules/simulatorTrainings/common/slices/student'
import {
  startSimulatorExerciseSession,
  getSimulatorExerciseUserSchedule,
} from 'modules/simulatorTrainings/student/studentLed/TrainingDetails/api/trainingDetailsService'
import {
  TrainingDetailsState,
  ApiStartSimulatorExerciseSessionResponse,
  ApiSimulatorExerciseUserScheduleResponse,
} from './types'

const initialState: TrainingDetailsState = {
  startLink: {},
  userScheduleDetailsData: {},
}

const trainingDetailsSlice = createSlice({
  name: 'simulatorTrainingStudentSLTrainingDetails',
  initialState,
  reducers: {
    linkLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiStartSimulatorExerciseSessionResponse>>
    ) {
      state.startLink = action.payload
    },
    clearLink(state) {
      state.startLink = initialState.startLink
    },
    userScheduleDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSimulatorExerciseUserScheduleResponse>>
    ) {
      state.userScheduleDetailsData = action.payload
    },
    clearUserScheduleDetailsData(state) {
      state.userScheduleDetailsData = initialState.userScheduleDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

export const { linkLoaded, clearLink, userScheduleDetailsLoaded, clearUserScheduleDetailsData } =
  trainingDetailsSlice.actions
export default trainingDetailsSlice.reducer

export const startSimulatorExercise = (scheduleId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      startLink: () => startSimulatorExerciseSession(scheduleId),
    },
    payloadAction: linkLoaded,
    shouldShowGlobalLoading: true,
    enableErrorNotification: true,
  })
}

export const loadExerciseUserScheduleData = (scheduleId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      details: () => getSimulatorExerciseUserSchedule(scheduleId),
    },
    payloadAction: userScheduleDetailsLoaded,
    nextAction: {
      action: handleLoadExerciseDetailsData,
      params: { payloadAction: userScheduleDetailsLoaded },
    },
  })
}

export const reloadExerciseUserScheduleData = (scheduleId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      details: () => getSimulatorExerciseUserSchedule(scheduleId),
    },
    payloadAction: userScheduleDetailsLoaded,
    getResultToKeep: ({ simulatorTrainingStudentSLTrainingDetails }) =>
      simulatorTrainingStudentSLTrainingDetails.userScheduleDetailsData.result,
  })
}
